import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import BrandMarquee from "@/components/BrandMarquee";

export default function Brands() {
  const [brands, setBrands] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/brands").then(({ data }) => setBrands(data));
  }, []);

  return (
    <div className="pt-20">
      <section className="bg-ink text-cream">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
          <p className="overline text-sand">Colecția noastră</p>
          <h1 className="font-display text-5xl md:text-8xl tracking-tight mt-3">Brandurile noastre</h1>
          <p className="text-cream/60 max-w-xl mt-6 leading-relaxed">
            Colaborăm exclusiv cu producători recunoscuți internațional, pentru a-ți oferi o selecție
            de cafea boabe de cea mai înaltă calitate.
          </p>
        </div>
      </section>

      <BrandMarquee dark={false} />

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {brands.map((b, i) => (
            <Reveal key={b.name} delay={(i % 3) * 0.08}>
              <Link to={`/produse?q=${encodeURIComponent(b.name)}`} className="group block" data-testid={`brand-card-${b.name}`}>
                <div className="relative overflow-hidden aspect-[3/2] bg-white flex items-center justify-center p-10">
                  {b.logo ? (
                    <img
                      src={b.logo}
                      alt={b.name}
                      className="max-h-full max-w-full object-contain transition-transform duration-[900ms] group-hover:scale-105"
                    />
                  ) : (
                    <span className="font-display text-3xl text-ink/70">{b.name}</span>
                  )}
                  <ArrowUpRight className="absolute top-4 right-4 text-ink opacity-0 group-hover:opacity-100 transition-opacity" size={22} />
                </div>
                <div className="flex items-baseline justify-between mt-5 border-b border-line pb-4">
                  <h3 className="font-display text-3xl tracking-tight group-hover:text-roast transition-colors">{b.name}</h3>
                  <span className="overline text-ink/40">0{i + 1}</span>
                </div>
                <p className="text-muted-foreground text-sm leading-relaxed mt-4">{b.description}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
